import { safeLocalStorage } from "./safeBrowserStorage"

// Session-scoped flag: dismissing the unsupported-browser warning must not carry over to another
// inspection opened later on the same device. The desktop block is not dismissable at all.
const DISMISSED_KEY_PREFIX = "browserWarningDismissed:"

export function hasDismissedBrowserWarning(sessionId: string): boolean {
  return safeLocalStorage.getItem(DISMISSED_KEY_PREFIX + sessionId) === "1"
}

export function markBrowserWarningDismissed(sessionId: string): void {
  safeLocalStorage.setItem(DISMISSED_KEY_PREFIX + sessionId, "1")
}
